import { AppChannel, Channel } from "@/config/channel"
import { Img } from "../ui/image"
import { BaseHeader } from "./base-header"
import { BaseHeaderNoCloseBtn } from "./base-header-no-close-btn"
import { HeaderVariants } from "./factory-header.types"
import { PokerstarsLogo } from "./pokerstars/pokerstars-logo"
import { HomePageLogoLink } from "./sisal/home-page-logo-link"
import { SisalQuestionarioHeader } from "./sisal/questionario-header"
import { SisalLogo } from "./sisal/sisal-logo"
import { SisalUploadDocHeader } from "./sisal/upload-doc-header"
import { HomePageSnaiLogoLink } from "./snai/home-page-logo-link"

type FactoryHeaderProps = {
  variant?: HeaderVariants
  siteid?: Channel
}

const AppChannelsWithoutHeader: Channel[] = [
  AppChannel.ClientDesktopSisalPoker,
  AppChannel.AppSisalPoker,
  AppChannel.AppCasinoHub,
  AppChannel.AppMobileScommesse,
  AppChannel.AppLottery,
  AppChannel.AppCasinoSnai,
]

export function FactoryHeader({
  variant = HeaderVariants.base,
  siteid,
}: FactoryHeaderProps) {
  const hideSiteHeader =
    siteid != null && AppChannelsWithoutHeader.includes(siteid)

  if (hideSiteHeader) return null

  const APP_VENDOR =
    typeof window !== "undefined" ? window.APP_VENDOR : process.env.APP_VENDOR

  if (APP_VENDOR === "pokerstars") {
    switch (variant) {
      case HeaderVariants.noCloseButton:
        return (
          <BaseHeaderNoCloseBtn
            homePageLogoLink={
              <Img
                src="/assets/logo/logo-pokerstars.svg"
                alt="logo"
                width={114}
                height={20}
                className="max-h-7"
              />
            }
          />
        )
      default:
        return <BaseHeader homePageLogoLink={<PokerstarsLogo />} />
    }
  }
  if (APP_VENDOR === "snai") {
    switch (variant) {
      case HeaderVariants.noCloseButton:
        return (
          <BaseHeaderNoCloseBtn homePageLogoLink={<HomePageSnaiLogoLink />} />
        )
      default:
        return <BaseHeader homePageLogoLink={<HomePageSnaiLogoLink />} />
    }
  }

  switch (variant) {
    case HeaderVariants.noCloseButton:
      return (
        <BaseHeaderNoCloseBtn
          homePageLogoLink={<SisalLogo channel={siteid} />}
        />
      )
    case HeaderVariants.questionario:
      return (
        <SisalQuestionarioHeader
          homePageLogoLink={<HomePageLogoLink siteid={siteid} />}
        />
      )
    case HeaderVariants.uploadDoc:
      return (
        <SisalUploadDocHeader
          homePageLogoLink={<HomePageLogoLink siteid={siteid} />}
        />
      )
    default:
      return (
        <BaseHeader homePageLogoLink={<HomePageLogoLink siteid={siteid} />} />
      )
  }
}
